import { Module } from '../Module';

export class SiteIdValidRegExp {
  private static Chars: string = 'A-Za-z0-9\-\_';
  public static InvalidFind: RegExp = new RegExp('[^'+SiteIdValidRegExp.Chars+']', 'g');
  public static InvalidTest: RegExp = new RegExp('^['+SiteIdValidRegExp.Chars+']+$');
}

Module.instance().directive('tbSiteIdInputValidator',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
       link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {

        ctrl.$parsers.push((inputId: any) => {
          ctrl.$setValidity('siteId', SiteIdValidRegExp.InvalidTest.test(inputId));
          return inputId;
        });
      }
    };
  }
);
